import { render, staticRenderFns } from "./informacion.vue?vue&type=template&id=49766d1e"
import script from "./informacion.vue?vue&type=script&lang=js"
export * from "./informacion.vue?vue&type=script&lang=js"
import style0 from "./informacion.vue?vue&type=style&index=0&id=49766d1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports